module.exports = "<div class=\"sk-spinner sk-spinner-wave\">\r\n    <div class=\"sk-rect1\"></div>\r\n    <div class=\"sk-rect2\"></div>\r\n    <div class=\"sk-rect3\"></div>\r\n    <div class=\"sk-rect4\"></div>\r\n    <div class=\"sk-rect5\"></div>\r\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/spinners/waveSpinner.component.html
// module id = ./src/app/components/common/spinners/waveSpinner.component.html
// module chunks = main